var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPyth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 36,
    viewBox: "0 0 106 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_10885_28350)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M40.2234 20.8678V18.4515H45.9561C46.8325 18.4515 47.5168 18.2028 48.0075 17.7053C48.4981 17.2078 48.7434 16.5521 48.7434 15.7413C48.7434 14.9305 48.4981 14.2618 48.0075 13.7772C47.5168 13.2927 46.8325 13.0504 45.9561 13.0504H38.398V24.8395H35.9238V10.5518H45.9561C46.7809 10.5518 47.5168 10.6729 48.1656 10.9152C48.8128 11.1574 49.36 11.4982 49.8054 11.9376C50.2508 12.3769 50.5914 12.9099 50.827 13.5382C51.0626 14.1665 51.1805 14.8739 51.1805 15.6605C51.1805 16.4471 51.0626 17.1368 50.827 17.7732C50.5914 18.4079 50.2508 18.9555 49.8054 19.4142C49.36 19.8728 48.8144 20.2298 48.1656 20.485C47.5184 20.7402 46.7809 20.8678 45.9561 20.8678H40.2234Z",
    fill: "#E6DAFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M59.2992 24.8362V19.4125L51.7217 10.5518H55.0787L60.6355 17.1336L66.2102 10.5518H69.3912L61.7927 19.4125V24.8362H59.2992Z",
    fill: "#E6DAFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M77.9924 24.8362V13.0472H71.4268V10.5518H87.0613V13.0472H80.4863V24.8362H77.9924Z",
    fill: "#E6DAFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M102.656 10.5518H105.14V24.8362H102.656V10.5518Z",
    fill: "#E6DAFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M91.943 24.8362V18.6534H101.184V16.4422H91.943V10.5518H89.459V24.8362H91.943Z",
    fill: "#E6DAFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M18.0823 14.2897C18.0823 16.2619 16.4845 17.8608 14.5138 17.8608V21.432C18.4551 21.432 21.6507 18.234 21.6507 14.2897C21.6507 10.3455 18.4551 7.14746 14.5138 7.14746C13.2146 7.14746 11.9944 7.49474 10.9454 8.10363C8.81174 9.33763 7.37695 11.6457 7.37695 14.2897V32.1453L10.5855 35.3563L10.9454 35.7164V14.2897C10.9454 12.3176 12.5432 10.7186 14.5138 10.7186C16.4845 10.7186 18.0823 12.3176 18.0823 14.2897Z",
    fill: "#E6DAFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M14.515 0C11.9149 0 9.47782 0.696135 7.37809 1.91235C6.03367 2.68924 4.82967 3.67934 3.80966 4.83741C1.58886 7.35542 0.241211 10.6633 0.241211 14.2845V24.9978L3.80966 28.569V14.2845C3.80966 11.1123 5.18796 8.26157 7.37809 6.29913C8.40781 5.37849 9.61667 4.65167 10.9466 4.18327C12.0617 3.78594 13.2641 3.57112 14.515 3.57112C20.4269 3.57112 25.2203 8.36814 25.2203 14.2845C25.2203 20.2008 20.4269 24.9978 14.515 24.9978V28.569C22.3991 28.569 28.7888 22.173 28.7888 14.2845C28.7888 6.39602 22.3991 0 14.515 0Z",
    fill: "#E6DAFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10885_28350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105.517,
    height: 36,
    fill: "white",
    transform: "translate(0.241211)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyth);
export default __webpack_public_path__ + "static/media/pyth.49e1af28a077ef1e62268a7166656737.svg";
export { ForwardRef as ReactComponent };